import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl text-secondary-200"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">{t('site.name')}</span>
            </div>
            <p className="text-secondary-200 text-sm leading-relaxed">{t('site.tagline')}</p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.links')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-secondary-200 hover:text-background-50 text-sm transition-colors cursor-pointer">{t('nav.home')}</Link>
              <Link to="/category/self-identity" className="text-secondary-200 hover:text-background-50 text-sm transition-colors cursor-pointer">{t('nav.categories')}</Link>
              <Link to="/about" className="text-secondary-200 hover:text-background-50 text-sm transition-colors cursor-pointer">{t('nav.about')}</Link>
              <a href="/privacy" className="text-secondary-200 hover:text-background-50 text-sm transition-colors cursor-pointer">{t('footer.privacy')}</a>
              <a href="/terms" className="text-secondary-200 hover:text-background-50 text-sm transition-colors cursor-pointer">{t('footer.terms')}</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.social')}</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-secondary-500 text-background-50 transition-colors cursor-pointer" aria-label="Weibo">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-secondary-500 text-background-50 transition-colors cursor-pointer" aria-label="WeChat">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-secondary-500 text-background-50 transition-colors cursor-pointer" aria-label="Xiaohongshu">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700">
          <p className="text-secondary-300 text-sm text-center">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}